(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBar = (root) => {
      const track = root.querySelector('[id^="AnnouncementTrack-"]');
      const segment = root.querySelector('[id^="AnnouncementSegment-"]');
      const clone = root.querySelector('.announcement-bar__segment--clone');
      if (!segment || !clone) return;
      if (!track) return;
      if (!segment.dataset.baseContent) {
        segment.dataset.baseContent = segment.innerHTML.trim();
      }
      const baseContent = segment.dataset.baseContent;
      if (!baseContent) return;

      const viewportWidth = root.clientWidth || window.innerWidth || 0;
      if (viewportWidth < 40) {
        window.requestAnimationFrame(() => initBar(root));
        return;
      }

      let segmentHtml = baseContent;
      segment.innerHTML = segmentHtml;
      clone.innerHTML = '';

      let safeGuard = 0;
      while (segment.scrollWidth < viewportWidth * 1.3 && safeGuard < 10) {
        segmentHtml += baseContent;
        segment.innerHTML = segmentHtml;
        safeGuard += 1;
      }

      clone.innerHTML = segment.innerHTML;
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(el => {
  el.setAttribute('tabindex', '-1');
});

      track.style.setProperty("--announcement-scroll-distance", `${segment.scrollWidth}px`);
      track.dataset.loopReady = "true";
    };

    const bars = document.querySelectorAll('[id^="AnnouncementBar-"]');
    bars.forEach((root) => {
      const run = () => initBar(root);
      run();
      window.addEventListener('resize', run, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var LIMIT = parseInt('{{ section.settings.truncate_at | default: 120 }}', 10);
  var sid = '{{ section.id }}';

  document.querySelectorAll('.gr-card-text-' + sid).forEach(function (p) {
    var full = p.getAttribute('data-full') || p.textContent.trim();
    var limit = parseInt(p.getAttribute('data-truncate') || LIMIT, 10);
    if (full.length <= limit) return;

    var short = full.slice(0, limit).trimEnd() + '…';
    p.textContent = short;

    var btn = document.createElement('button');
    btn.className = 'gr-show-more-' + sid;
    btn.textContent = 'Show More';
    var expanded = false;

    btn.addEventListener('click', function () {
      expanded = !expanded;
      p.textContent = expanded ? full : short;
      btn.textContent = expanded ? 'Show Less' : 'Show More';
      p.parentNode.insertBefore(btn, p.nextSibling);
    });

    p.parentNode.insertBefore(btn, p.nextSibling);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
